import React, { useEffect, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import useTheme from '@material-ui/styles/useTheme';
import makeStyles from "@material-ui/styles/makeStyles";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { MaterialTable } from '../../components';
import api from '../../common/api';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
}));

const AvailableStock = ({ showError, showMessage, match }) => {
    const theme = useTheme();
    const farmID = match.params['farmID'];
    const [loading, setLoading] = useState(false);
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });
    const [MedicineVaccinationStockList, setMedicineVaccinationStockList] = useState(null);
    const getAllMedicineandVaccinactionStockList = () => {
        showError('');
        showMessage('');

        const response = api.post(`/medicine-stock/get-medicine-vaccination-list/${farmID}`, {});
        response.then(res => {
            console.log(res, "34**");
            setMedicineVaccinationStockList(res);

        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Medicine and Vaccination List');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });

        return response;
    }

    const onload = () => {
        setLoading(true);
        Promise.all([getAllMedicineandVaccinactionStockList()]).finally(() => {
            setLoading(false);
        });
    }
    useEffect(onload, []);
    // PDF Export without changing UI
    const handleExportPDF = (data, title) => {
        try {
            const doc = new jsPDF();

            const header = ['Name', 'Available Quantity (units)', 'Average Cost per unit'];
            const rows = data.map(row => [
            row.materialName,
            row.availableStock?.toFixed(2),
            row?.averageCost?.toFixed(2) || '',
            ]);

            doc.text(title, 14, 15);
            doc.autoTable({
            head: [header],
            body: rows,
            startY: 20,
            theme: 'grid',
            styles: {
                fontSize: 10,
                halign: 'center',
                cellPadding: 3,
            },
            headStyles: {
                fillColor: [60, 66, 77], 
                textColor: 255,         
                fontStyle: 'bold',
                halign: 'center',
            },
            bodyStyles: {
                textColor: 50,
            },
            });

            doc.save(`${title}.pdf`);
        } catch (err) {
            console.error("PDF Export Failed:", err);
        }
    };
    //Medicine and vaccination CSV Export
    const handleExportCSV = (data,fileName) => {
        const header = ['Name', 'Available Quantity (units)', 'Average Cost per unit'];
        const rows = data.map(row => [
        row.materialName,
        row.availableStock?.toFixed(2),
        row?.averageCost?.toFixed(2) || '',
        ]);

        const csvContent = [header, ...rows]
        .map(e => e.join(','))
        .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return <div className={classes.root}>
        <Grid
            container
            justify='space-between'
            alignItems='flex-end'
            className={classes.topBar}
        >
            <Grid>
                <Typography display="block" variant="h3" gutterBottom>
                    Available Stock
                </Typography>
            </Grid>
        </Grid>
        <MaterialTable
            isLoading={loading}
            columns={[
                { title: 'Name', field: 'materialName', editable: 'never'},
                { title: 'Available Quantity (units)', field: 'availableStock', editable: 'never', render:rd=>rd.availableStock.toFixed(2)},
                { title: 'Average Cost per unit', field: 'averageCost', editable: 'never', render:rd=>rd?.averageCost?.toFixed(2)|| ""},
            ]}
            data={MedicineVaccinationStockList !== null && MedicineVaccinationStockList !== undefined && 
                MedicineVaccinationStockList["Medicine"] !== undefined && Array.isArray(MedicineVaccinationStockList["Medicine"]) && MedicineVaccinationStockList["Medicine"].length > 0 
                ? MedicineVaccinationStockList["Medicine"] : []}
            title='Medicines'
            options={{
                actionsColumnIndex: -1,
                search: true,
                showTitle: true,
                toolbar: true
            }}
            actions={[
            {
                icon: 'save_alt',
                tooltip: 'Export to Excel',
                isFreeAction: true,
                onClick: () => {
                const data =
                    Array.isArray(MedicineVaccinationStockList?.Medicine)
                    ? MedicineVaccinationStockList.Medicine
                    : [];
                handleExportCSV(data,'Medicines');
                },
            },
            {
                icon: () => <PictureAsPdfIcon />,
                tooltip: 'Export to Pdf',
                isFreeAction: true,
                onClick: () => {
                const data =
                    Array.isArray(MedicineVaccinationStockList?.Medicine)
                    ? MedicineVaccinationStockList.Medicine
                    : [];
                handleExportPDF(data,`Medicines (${window.localStorage.getItem("farmName")})`);
                },
            }
            ]}
        />
        <br></br>
        <br></br>
        <MaterialTable
            columns={[
                { title: 'Name', field: 'materialName', editable: 'never' },
                { title: 'Available Quantity (units)', field: 'availableStock', editable: 'never', render:rd=>rd.availableStock.toFixed(2) },
                { title: 'Average Cost per unit', field: 'averageCost', editable: 'never', render:rd=>rd?.averageCost?.toFixed(2)|| ""},
            ]}
            title='Vaccinations'
            data={MedicineVaccinationStockList !== null && MedicineVaccinationStockList !== undefined && 
                MedicineVaccinationStockList["Vaccination"] !== undefined && Array.isArray(MedicineVaccinationStockList["Vaccination"]) && MedicineVaccinationStockList["Vaccination"].length > 0 
                ? MedicineVaccinationStockList["Vaccination"] : []}
            options={{
                actionsColumnIndex: -1,
                search: true,
                showTitle: true,
                toolbar: true
            }}
             actions={[
            {
                icon: 'save_alt',
                tooltip: 'Export to Excel',
                isFreeAction: true,
                onClick: () => {
                const data =
                    Array.isArray(MedicineVaccinationStockList?.Vaccination)
                    ? MedicineVaccinationStockList.Vaccination
                    : [];
                handleExportCSV(data,'Vaccinations');
                },
            },
             {
                icon: () => <PictureAsPdfIcon />,
                tooltip: 'Export to Pdf',
                isFreeAction: true,
                onClick: () => {
                const data =
                    Array.isArray(MedicineVaccinationStockList?.Vaccination)
                    ? MedicineVaccinationStockList.Vaccination
                    : [];
                handleExportPDF(data,`Vaccinations (${window.localStorage.getItem("farmName")})`);
                },
            }
            ]}
        />
    </div>
}

export default AvailableStock;